import { useStripe } from "@stripe/react-stripe-js";
import Cards from "react-credit-cards";
import React, { useEffect, useState } from "react";
import ShoppingAPI from "../../store/shopping/shopping.api";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardContent, CardHeader, Grid } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import "react-credit-cards/es/styles-compiled.css";

export default function StripePaymentForm(props) {
    const { paymentConfig } = props;
    const history = useNavigate();
    const [elements, setElements] = useState(null);
    const stripe = useStripe();
    const [existingCard, setExistingCard] = useState({});
    const [secret, setSecret] = useState("");
    const [isClicked, setClicked] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (elements) {
            var paymentElement = elements.create("payment", {
                wallets: {
                    applePay: "auto",
                    googlePay: "auto",
                },
            });

            paymentElement.mount("#payment-element");
        }
    }, [elements]);

    useEffect(() => {
        const getSecr = async () => {
            if (props.type === "user-subscription") {
                await ShoppingAPI.CreateSubscription({
                    creator: props.userId,
                    billingPeriod: props.billingPeriod.toLowerCase(),
                }).then((res) => {
                    const clientSecret = res.data.clientSecret;
                    var myElements = stripe.elements({
                        clientSecret: clientSecret,
                    });
                    setElements(myElements);
                    setSecret(res.data.clientSecret);
                });
            } else if (props.type === "vip-circle") {
                await ShoppingAPI.CreateVIPSubscription({
                    creator: props.vipCircle.user._id,
                    vip: props.vipCircle._id,
                    billingPeriod: props.billingPeriod.toLowerCase(),
                }).then(async (res) => {
                    const clientSecret = res.data.clientSecret;
                    var myElements = stripe.elements({
                        clientSecret: clientSecret,
                    });
                    setElements(myElements);
                    setSecret(res.data.clientSecret);
                });
            } else if (props.type === "account-upgrade") {
                await ShoppingAPI.CreateUpgradeAccountSubscription({
                    billingPeriod: props.billingPeriod,
                }).then(async (res) => {
                    const clientSecret = res.data.clientSecret;
                    var myElements = stripe.elements({
                        clientSecret: clientSecret,
                    });
                    setElements(myElements);
                    setSecret(res.data.clientSecret);
                });
            } else if (props.type === "checkout") {
                let dis = {};
                let courier = {};
                Object.keys(props.discount).forEach((x) => {
                    dis[x] = props.discount[x].discount;
                });

                Object.keys(props.courier).forEach((x) => {
                    courier[x] = props.courier[x];
                });
                await ShoppingAPI.CreateOrderGroup({
                    products: props.cart.cartItems.map(
                        (cartItem) => cartItem.product._id
                    ),
                    deliveryAddress: props.billingAddress,
                    paymentMethod: "fpx",
                    shipment: props.shipment,
                    discount: dis,
                    courier: courier,
                }).then(async (res) => {
                    const clientSecret = res.data.clientSecret;
                    var myElements = stripe.elements({
                        clientSecret: clientSecret,
                    });
                    setElements(myElements);
                    setSecret(res.data.clientSecret);
                });
            }
        };
        if (stripe) {
            getSecr();
        }
    }, [props.type, stripe]);

    const processPayment = async (clientSecret) => {
        if (existingCard && existingCard.id) {
            const { error } = await stripe.confirmCardPayment(clientSecret, {
                payment_method: existingCard.id,
            });
            if (!error) {
                props.OnSuccess();
            } else {
                props.OnError(error);
                setClicked(false);
            }
        } else {
            const { error } = await stripe.confirmPayment({
                elements: elements,
                redirect: "if_required",
                confirmParams: {
                    return_url:
                        props.type === "checkout"
                            ? process.env.REACT_APP_URL + "/page/order"
                            : process.env.REACT_APP_URL + "/",
                },
            });
            if (!error) {
                props.OnSuccess();
            } else {
                props.OnError(error);
                setClicked(false);
            }
        }
    };

    const handleSubmit = async (event) => {
        if (event) {
            event.preventDefault();
        }

        if (!stripe || !elements) {
            return;
        }

        processPayment(secret);
        setClicked(true);
    };

    const handleCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        } else {
            history.goBack();
        }
    };

    return (
        <div className="bg-white rounded-full border border-black-10 rounded-xl p-3">
            <h3 className="text-base font-bold text-ebony-color my-2 text-xl">
                Payment Method
            </h3>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2} style={{ height: "100%" }}>
                    <Grid item xs={12} sm={12}>
                        <Card elevation={0}>
                            <CardContent>
                                <div id="payment-element"></div>

                                <Accordion expanded={open} className="mt-4">
                                    <AccordionSummary
                                        expandIcon={
                                            <ExpandMore
                                                onClick={() => setOpen(!open)}
                                            />
                                        }
                                    >
                                        <Typography>
                                            Use Existing Card
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container>
                                            {paymentConfig &&
                                                paymentConfig.cards &&
                                                paymentConfig.cards.map(
                                                    (item) => {
                                                        return (
                                                            <Grid
                                                                key={item.id}
                                                                item
                                                                md={12}
                                                                lg={12}
                                                                sm={12}
                                                                xs={12}
                                                                className="mt-4"
                                                            >
                                                                <Card
                                                                    elevation={
                                                                        15
                                                                    }
                                                                    style={{
                                                                        background:
                                                                            "transparent",
                                                                    }}
                                                                    onClick={() =>
                                                                        setExistingCard(
                                                                            item
                                                                        )
                                                                    }
                                                                    variant={
                                                                        existingCard.id ===
                                                                        item.id
                                                                            ? "elevation"
                                                                            : "outlined"
                                                                    }
                                                                >
                                                                    <CardContent>
                                                                        <Cards
                                                                            cvc={
                                                                                "***"
                                                                            }
                                                                            expiry={
                                                                                item.expMonth +
                                                                                "/" +
                                                                                item.expYear
                                                                            }
                                                                            preview={
                                                                                true
                                                                            }
                                                                            name={
                                                                                item.name
                                                                            }
                                                                            number={
                                                                                item.last4
                                                                            }
                                                                            issuer={
                                                                                item.brand
                                                                            }
                                                                        />
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>
                                                        );
                                                    }
                                                )}
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        {props.description}
                        <div className="flex items-center justify-between">
                            <Button
                                type="button"
                                variant="contained"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={!stripe || isClicked}
                                variant="contained"
                                color="secondary"
                                className="mb-2"
                            >
                                Pay Now
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}
